import React, { FC, FormEvent, useState } from 'react';
import { useRecoilState } from 'recoil';
import { singleProblemParametrizationState } from '../../atoms/singleProblemParametrizationState';
import styles from './SingleProblemParametrization.module.scss';

interface SingleProblemParametrizationProps {
  done: () => void;
}

const SingleProblemParametrization: FC<SingleProblemParametrizationProps> = (props) => {
  const [singleProblemParametrization, setSingleProblemParametrization] = useRecoilState(
    singleProblemParametrizationState
  );
  const [singleProblemParametrizationBuffer, setSingleProblemParametrizationBuffer] = useState(
    singleProblemParametrization
  );

  const handleInput = (prop: 'noNodes' | 'maxCapacity', e: FormEvent<HTMLInputElement>) => {
    setSingleProblemParametrizationBuffer((old) => {
      const { value } = e.target as HTMLInputElement;
      return {
        ...old,
        [prop]: value
      };
    });
  };

  const cleanUpInput = (prop: 'noNodes' | 'maxCapacity') => {
    let value = parseInt(`${singleProblemParametrizationBuffer[prop]}`, 10);
    if (Number.isNaN(value) || value < 1) {
      value = singleProblemParametrization[prop];
    }
    setSingleProblemParametrization((old) => {
      return {
        ...old,
        [prop]: value
      };
    });
    setSingleProblemParametrizationBuffer((old) => {
      return {
        ...old,
        [prop]: `${value}`
      };
    });
  };

  return (
    <div className={styles.SingleProblemParametrization} data-testid="SingleProblemParametrization">
      <div className={styles.content}>
        <div className={styles.row}>
          <p>Number of Nodes</p>
          <input
            type="number"
            value={singleProblemParametrizationBuffer.noNodes}
            onInput={(e) => handleInput('noNodes', e)}
            onMouseLeave={() => cleanUpInput('noNodes')}
            onBlur={() => cleanUpInput('noNodes')}
          />
        </div>
        <div className={styles.row}>
          <p>Maximum Edge Capacity</p>
          <input
            type="number"
            value={singleProblemParametrizationBuffer.maxCapacity}
            onInput={(e) => handleInput('maxCapacity', e)}
            onMouseLeave={() => cleanUpInput('maxCapacity')}
            onBlur={() => cleanUpInput('maxCapacity')}
          />
        </div>
        <div className={styles.row}>
          <button
            type="button"
            onClick={props.done}
            onMouseEnter={() => {
              cleanUpInput('noNodes');
              cleanUpInput('maxCapacity');
            }}>
            Generate
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleProblemParametrization;
